import { Tag } from "@design-system/Tag/Tag";
import {
    Cell,
    handleClick,
    handleRemove,
    leftIcon,
} from "./TagPlaygroundMatrixShared";
import styles from "./TagPlayground.module.scss";

export const LgNormalRow = () => (
    <>
        <span className={styles.rowLabel}>primary</span>
        <Cell>
            <Tag size="lg">Tag</Tag>
        </Cell>
        <Cell>
            <Tag size="lg" outline>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="lg" leftIcon={leftIcon}>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="lg" outline leftIcon={leftIcon}>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="lg" numeric>
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag size="lg" numeric outline>
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag size="lg" onRemove={handleRemove}>
                recipient@kick.co
            </Tag>
        </Cell>
        <Cell>
            <Tag size="lg" outline onRemove={handleRemove}>
                recipient@kick.co
            </Tag>
        </Cell>
    </>
);

export const LgHoverRow = () => (
    <>
        <span className={styles.rowLabel}>primary</span>
        <Cell>
            <Tag size="lg" onClick={handleClick} data-forced-state="hover">
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="lg"
                outline
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="lg"
                leftIcon={leftIcon}
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="lg"
                outline
                leftIcon={leftIcon}
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="lg"
                numeric
                onClick={handleClick}
                data-forced-state="hover"
            >
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="lg"
                numeric
                outline
                onClick={handleClick}
                data-forced-state="hover"
            >
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag size="lg" onRemove={handleRemove} data-forced-state="hover">
                recipient@kick.co
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="lg"
                outline
                onRemove={handleRemove}
                data-forced-state="hover"
            >
                recipient@kick.co
            </Tag>
        </Cell>
    </>
);

export const LgHoverXRow = () => (
    <>
        <span className={styles.rowLabel}>primary</span>
        <Cell>
            <Tag size="lg" onRemove={handleRemove} data-forced-state="hoverX">
                recipient@kick.co
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="lg"
                outline
                onRemove={handleRemove}
                data-forced-state="hoverX"
            >
                recipient@kick.co
            </Tag>
        </Cell>
    </>
);
